import {
  IAftnMessage,
  ISigmet,
  IValidity,
} from "@naviair-utm/node-shared-interfaces";
import * as commParsers from "../CommonParsers";
import { icaoRegex, sigmetBodyRegex } from "./SigmetRegExp";
import { seriesParser, validityParser } from "./SigmetParsers";

/**
 * Parse a sigmet message and return an ISigmet object or null if the input
 * does not comply with the format, eg. not a sigmet message
 * @param input
 * @returns
 */
export const sigmetParser = (input: string): IAftnMessage<ISigmet> => {
  let sigmetParsed: IAftnMessage<ISigmet> = {} as IAftnMessage<ISigmet>;
  sigmetParsed.type = "SIGMET";
  sigmetParsed.parsedMessage = {} as ISigmet;
  // Replace multiple consecutive whitespaces with a single whitespace
  const trimmedSigmet = commParsers.trimmer(input);
  sigmetParsed.rawInput = trimmedSigmet;

  if (input.toUpperCase().search("SIGMET") !== -1) {
    // Get ICAO code from Sigmet
    const icao: string = commParsers.getStringFromRegExp(
      trimmedSigmet,
      icaoRegex
    );
    if (icao !== null) {
      sigmetParsed.icao = icao;
    }

    // Get the series, this sigmet is part of
    const series = seriesParser(trimmedSigmet);
    if (series !== null) {
      sigmetParsed.parsedMessage.series = series.series;
      sigmetParsed.parsedMessage.seriesIndex = series.seriesIndex;
    }

    // Get the start date time and expire date time of the sigmet
    const validity: IValidity | undefined = validityParser(trimmedSigmet);
    if (validity) {
      sigmetParsed.validity = validity;
    } else {
      sigmetParsed.errors.push("No svalidity set for message");
    }

    // Get the body of the sigmet containing the actual information
    const body: string = commParsers.getStringFromRegExp(
      trimmedSigmet,
      sigmetBodyRegex
    );

    if (body !== null) {
      sigmetParsed.parsedMessage.body = body;
    } else {
      sigmetParsed.errors.push("Failed parsing contents of body");
    }
  } else {
    // The string doesn't contain "SIGMET" which it should
    sigmetParsed.errors.push(
      "Message didn't contain SIGMET which it should according to ICAO"
    );
  }

  return sigmetParsed;
};
